import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import 'tooltipster';

const classes = {
	stateTooltipVisible: 'state-m-tooltip--is-visible',
	stateHeaderPos0: 'state-m-navigation--scroll-0-position',
	tooltipCloser: 'js-m-tooltip__closer',
};

@createModule('Tooltip')
/**
 * tooltip module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class Tooltip extends TerrificSpec {
	start(resolve: Function) {
		const $ctx = $(this._ctx);
		$ctx.hide();

		const $trigger = this._getTriggerElement();

		this.initTooltip();

		if ($ctx.hasClass(`${classes.stateTooltipVisible}`)) {
			setTimeout(() => {
				$trigger.trigger('click');
			}, 1000);
			$ctx.removeClass(`${classes.stateTooltipVisible}`);
		}

		resolve();
	}
	stop() {}
	initTooltip() {
		const $trigger = this._getTriggerElement() as any;
		const content = this._getTooltipContent();
		$trigger.tooltipster({
			theme: 'tooltipster-shadow',
			content: content,
			contentAsHTML: true,
			trigger: 'click',
			interactive: true,
			zIndex: 2,
			functionReady(instance: any) {
				instance._$tooltip.on('click', `.${classes.tooltipCloser}`, (ev: Event) => {
					ev.preventDefault();
					$trigger.trigger('click');
				});
			},
			functionPosition(instance: any, helper: any, position: any) {
				// fine tuning of tooltip position relative to trigger element
				if (position.side === 'top') {
					position.coord.top -= 16;
					position.coord.left += 8;
				} else if (position.side === 'bottom') {
					position.coord.top += 4;
				}
				return position;
			},
		});
	}
	_getTooltipContent() {
		return $(this._ctx).html();
	}
	_getTriggerElement() {
		return $(this._ctx).prev();
	}
}
